import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Misma tarjeta que el bloque de datos personales (#firstSectionStyle)
const InterviewNotesPanelStyled = styled.div`
  && {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    min-height: 0;
    background: ${color.background.default};
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;
  }

  .notes-header {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
  }

  /* Editar notas primero y, a su lado, mostrar al imprimir */
  .notes-actions {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 16px;

    /* ButtonWithIcon trae margin-left de 12 px: aquí lo separa el gap y se alinea con la nota */
    button {
      margin-left: 0 !important;
    }
  }

  .notes-print {
    margin: 0;

    .MuiFormControlLabel-label {
      font-size: 13px;
      color: ${color.text.secondary};
    }
  }

  .interviewerNote {
    padding: 16px 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.6;
    color: ${color.text.secondary};
    background: ${color.background.light};
    border-radius: 8px;
    white-space: pre-line;
    overflow-wrap: anywhere;

    p:last-child {
      margin-bottom: 0;
    }
  }

  .notes-empty {
    margin: 0;
    padding: 16px 20px;
    font-size: 13px;
    color: ${color.text.tertiary};
    border: 1px dashed ${color.border.default};
    border-radius: 8px;
  }

  .interviewerNote_metadata {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0;
    font-size: 12px;
    color: ${color.text.tertiary};
  }
`

export default InterviewNotesPanelStyled
